import { Component, Injector, input, Type } from '@angular/core';

interface WidgetInstance {
  component: Type<unknown>;
  injector: Injector;
}

@Component({
  selector: 'finxone-web-frontend-dynamic-widgets',
  standalone: false,
  template: `
    @if (widgetsInstance()?.length) {
    <!-- loop this to render all widgets -->
    @for (item of widgetsInstance(); track $index) {
    <div class="widget-host" id="web-app">
      <ng-container *ngComponentOutlet="item.component; injector: item.injector"> </ng-container>
    </div>
    } }
  `,
})
/**
 * Component responsible for managing and rendering dynamic widget instances within a layout zone.
 *
 * @remarks
 * The `DynamicWidgetsComponent` maintains a list of widget instances, allowing for flexible and dynamic
 * composition of widgets in the UI. It is typically used as part of a widget layout system where the
 * displayed widgets can change at runtime.
 *
 * @example
 * ```html
 * <finxone-web-frontend-dynamic-widgets [widgetsInstance]="myWidgets"></finxone-web-frontend-dynamic-widgets>
 * ```
 *
 * @property widgetsInstance - An input property that holds the array of widget instances to be rendered dynamically.
 */
export class DynamicWidgetsComponent {
  widgetsInstance = input<WidgetInstance[]>([]);
}
